__turbopack_context__.v({
  "card-media": "featured-courses-module-scss-module__3nZkdG__card-media",
  "card-wrapper": "featured-courses-module-scss-module__3nZkdG__card-wrapper",
  "featured-courses": "featured-courses-module-scss-module__3nZkdG__featured-courses",
  "heading": "featured-courses-module-scss-module__3nZkdG__heading",
  "item": "featured-courses-module-scss-module__3nZkdG__item",
  "list": "featured-courses-module-scss-module__3nZkdG__list",
});
